import {
  ArrayField,
  ArrayInput,
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  EditButton,
  List,
  ReferenceInput,
  required,
  SelectInput, //
  Show,
  ShowButton,
  SimpleForm,
  SimpleFormIterator,
  SimpleShowLayout,
  TextField,
  TextInput,
  useNotify,
} from "react-admin";
import { AssetBulkActionButtons } from "./components";

export const DrmProfileList = (props) => {
  return (
    <List {...props} bulkActionButtons={<AssetBulkActionButtons />}>
      <Datagrid>
        <TextField source="name" />
        <ArrayField source="settings">
          <Datagrid>
            <TextField source="platform" />
            <TextField source="drm" />
          </Datagrid>
        </ArrayField>
        <BooleanField source="is_default_video_setting" />
        <ShowButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};

const DrmProfileTitle = ({ record }) => {
  return <span>DrmProfile {record ? `${record.name}` : ""}</span>;
};

export const DrmProfileShow = (props) => (
  <Show {...props} title={<DrmProfileTitle />}>
    <SimpleShowLayout>
      <TextField source="name" />
      <ArrayField source="settings">
        <Datagrid>
          <TextField source="platform" />
          <TextField source="drm" />
        </Datagrid>
      </ArrayField>
      <BooleanField source="is_default_video_setting" />
    </SimpleShowLayout>
  </Show>
);

export const DrmProfileEdit = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };
  return (
    <Edit {...props} onFailure={onFailure} mutationMode="pessimistic" title={<DrmProfileTitle />}>
      <SimpleForm>
        <TextInput source="name" validate={required()} />
        <ArrayInput source="settings">
          <SimpleFormIterator>
            <ReferenceInput label="Platform" source="platform" reference="key-value-by-platform">
              <SelectInput optionText="name" optionValue="id" />
            </ReferenceInput>
            <ReferenceInput label="DRM" source="drm" reference="key-value-by-drm">
              <SelectInput optionText="name" optionValue="id" />
            </ReferenceInput>
          </SimpleFormIterator>
        </ArrayInput>
        <BooleanInput label="Default Video Settings" source="is_default_video_setting" />
      </SimpleForm>
    </Edit>
  );
};

const redirect = () => "/drm-profiles";
export const DrmProfileCreate = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };
  return (
    <Create {...props} onFailure={onFailure}>
      <SimpleForm redirect={redirect}>
        <TextInput source="name" validate={required()} />
        <ArrayInput source="settings">
          <SimpleFormIterator>
            <ReferenceInput label="Platform" source="platform" reference="key-value-by-platform">
              <SelectInput optionText="name" optionValue="id" />
            </ReferenceInput>
            <ReferenceInput label="DRM" source="drm" reference="key-value-by-drm">
              <SelectInput optionText="name" optionValue="id" />
            </ReferenceInput>
          </SimpleFormIterator>
        </ArrayInput>
        <BooleanInput label="Default Video Settings" source="is_default_video_setting" />
      </SimpleForm>
    </Create>
  );
};
